exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-callback-plugin,#asseco-callback .asseco-floaty-btn{background-color:#7c4dff}", ""]);

// exports
